import { render } from "./EditExerciseSheetQuestionType.vue?vue&type=template&id=5bd8bc1a"
import script from "./EditExerciseSheetQuestionType.vue?vue&type=script&lang=js"
export * from "./EditExerciseSheetQuestionType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__